import React from 'react'
import './staffHandBook.css'
import { handBookArray } from '../../utils';
import { Link } from 'react-router-dom';


const StaffHandBook = () => {

  return (
    <section className='staff__handbook'>
      
        {/* HEADING */}
        <div className="heading">
            <div className="heading__box">
                <div className="heading-item">
                    <h3 className="heading-title">Staff Hand Book | </h3>
                    <i class='bx bx-home heading__title-icon'></i>
                    <Link
                    to="/" className="heading-text">
                        Home <i class='bx bx-chevron-right heading-icon'></i>
                    </Link>
                    <span className="heading-text">
                        Staff Hand Book <i class='bx bx-chevron-right heading-icon'></i>
                    </span>
                </div>
                <p className="heading-text">
                  Staff Hand Book
                </p>
            </div>
        </div>

        {/* HANDBOOK CONTAINER */}
        <div className="handbook__container">

          <div className="handbook__container-heading">
              <h4 className="handbook__heading-title">
                Aspom Travels Agency Staff HandBook
              </h4>
              <a href="./ASPOM_Employee_handbook_V11.pdf" download 
              className="handbook__heading-link">Download pdf</a>
          </div>

          <div className="handbook__content">
              <input type="checkbox" name="" id="checkbox-cover" 
              className='handbook__checkbox-cover'/>
              {
                  handBookArray.map((item, i)=>(
                    <input type="checkbox" name="" id={`checkbox-page${i + 1}`} 
                    className='handbook__checkbox-cover'/>
              ))}

              <div className="handbook">

                <div className="handbook__cover">
                  <label htmlFor="checkbox-cover">
                  </label>
                </div>

                {
                  handBookArray.map((item, i)=>(
                    <div className={`handbook__page page${i + 1}`} key={i + 1}>
                        <label htmlFor={`checkbox-page${i + 1}`} className="front-page"> 
                            <img src={item} alt="" />
                        </label>
                        <label htmlFor={`checkbox-page${i + 1}`} className="back-page"> 
                        </label>
                        
                    </div>
                  ))
                }

                <div className="handbook__back-cover">
                  <label htmlFor="checkbox-cover"></label>
                </div>
              </div>
          </div>
        
        </div>
    </section>
  )
}

export default StaffHandBook